import { render, staticRenderFns } from "./SocialIcons.vue?vue&type=template&id=52b9789d&scoped=true&"
import script from "./SocialIcons.vue?vue&type=script&lang=js&"
export * from "./SocialIcons.vue?vue&type=script&lang=js&"
import style0 from "./SocialIcons.vue?vue&type=style&index=0&id=52b9789d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b9789d",
  null
  
)

export default component.exports